var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel margin--bottom" },
    [
      _c(
        "bar-card",
        { attrs: { bg: "border4" } },
        [
          _c("v-title", [_vm._v("项目建设")]),
          _c("div", { staticClass: "content" }, [
            _c("div", { staticClass: "img-box flex" }, [
              _c(
                "div",
                { staticClass: "ltarget flex-between" },
                _vm._l(_vm.baseList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "target",
                      style: { bottom: item.top },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "navValue", class: "navName" + index },
                        [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.value)),
                          ]),
                          _vm._v("（" + _vm._s(item.unit) + "） "),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "navTitle", class: "navName" + index },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      ),
                      _c("img", { attrs: { src: item.img } }),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c("div", { staticClass: "bgImg flex" }, [
              _c("img", {
                staticClass: "himg aimg",
                staticStyle: { width: "88%", margin: "auto" },
                attrs: {
                  src: require("images/index/xmjs/808fe4e2b8a803ac20b92ec43cfc7922.png"),
                },
              }),
              _c("img", {
                staticClass: "simg aimg",
                staticStyle: { width: "88%", margin: "auto" },
                attrs: {
                  src: require("images/index/xmjs/808fe4e2b8a803ac20b92ec43cfc792.png"),
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "progess" },
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "progessRow flex" },
                  [
                    _c("div", { staticClass: "name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "jdt flex", class: "ys" + index },
                      [
                        _c("el-progress", {
                          attrs: { percentage: item.value, "stroke-width": 10 },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }